function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { IvTrackType } from "../enums";
var _obj;
export var trackIconMap = (_obj = {}, _defineProperty(_obj, IvTrackType.Audio, IcBgm), _defineProperty(_obj, IvTrackType.Video, IcMovie), _defineProperty(_obj, IvTrackType.Hand, IcClick), _defineProperty(_obj, IvTrackType.Image, IcImage), _defineProperty(_obj, IvTrackType.Text, IcWord), _defineProperty(_obj, IvTrackType.Iv, IcInteraction), _obj);
